<template>
  <div class="slider-wrapper theme-default">
    <!--Carousel Wrapper-->
    <div
      id="carousel-thumb"
      class="carousel slide carousel-fade"
      data-ride="carousel"
    >
      <!--Slides-->
      <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
          <span
            style="
              position: absolute;
              left: 20px;
              top: 5%;
              text-shadow: 1px 1px 2px black, 0 0 1em darkorange;
            "
            class="main-slider__slide text-white"
          >
            <span style="font-size: 20px; display: block"
            >интернет-магазин</span
            >
            <span style="font-size: 35px" class="izhitsa"
            >Православный Продукт</span
            >
          </span>
          <!--          <span-->
          <!--            style="-->
          <!--              position: absolute;-->
          <!--              left: 20px;-->
          <!--              top: 60%;-->
          <!--              text-shadow: 1px 1px 2px black, 0 0 1em darkorange;-->
          <!--            "-->
          <!--            class="main-slider__slide text-white"-->
          <!--          >-->
          <!--            <span style="font-size: 1.5em; display: block"-->
          <!--            >по благословению</span-->
          <!--            >-->
          <!--            <span style="font-size: 1.5em" class="izhitsa"-->
          <!--            >митрополита Ставропольского и Невинномысского Кирилла</span-->
          <!--            >-->
          <!--          </span>-->
          <img
            v-lazy="{
              // src: require(`/src/assets/img/slider/IMG-20210630-WA0058.jpg`),
              src: require(`/src/assets/img/slider/3-03.jpg`),
              // loading: require(`/src/assets/img/opacity.png`),
              // error: require(`/src/assets/img/opacity.png`),
            }"
            class="d-block w-100 z-depth-3 rounded"
            alt=""
          />
        </div>
      </div>
      <!--/.Slides-->
    </div>
  </div>
  <!--/.Carousel Wrapper-->
</template>

<script>
export default {};
</script>

<style scoped></style>
